import { DoorCrewSeat } from './types';

export interface TurfSeatGroup {
  turfId: number | null;
  turf: DoorCrewSeat['turf'];
  seats: DoorCrewSeat[];
}

export function getSeatTurfId(seat: DoorCrewSeat): number | null {
  if (!seat?.turf) {
    return null;
  }
  if (typeof seat.turf === 'object') {
    if ('id' in seat.turf && seat.turf.id !== undefined) {
      return seat.turf.id;
    }
    return seat.turf._raw_id ?? null;
  }
  return seat.turf;
}

export function groupSeatsByTurf(seats: DoorCrewSeat[]): TurfSeatGroup[] {
  const groups: TurfSeatGroup[] = [];

  for (const seat of seats) {
    const turfId = getSeatTurfId(seat);
    const last = groups[groups.length - 1];

    if (last && last.turfId === turfId) {
      last.seats.push(seat);
    } else {
      groups.push({ turfId, turf: seat.turf, seats: [seat] });
    }
  }

  return groups;
}
